import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ErrorModel} from '../app.model';
import {ACTION_TYPES, ApiVersion} from '../app.types';
import {AppStore} from '../store/store';
import {HttpClientUtils} from '../utils/http-client.utils';
import {HttpInteraction} from '../utils/http-interactions.utils';
import {SegmentModel} from './segment.model';
import {Observable} from 'rxjs';
import {HttpClientWithCache} from '../utils/http-client-with-cache';
import {segmentCreated, segmentCreationError} from './segments.state';
import {apiVersionHeader} from './segments-client.service';

export interface SegmentAction {
  type: string;
  segments?: SegmentModel[];
  segment?: SegmentModel;
  error?: ErrorModel;
  segmentIsSelected?: boolean;
}

@Injectable({providedIn: 'root'})
export class SegmentService {

  constructor(public appStore: AppStore, private httpClientUtils: HttpClientUtils, private httpClient: HttpClientWithCache) {
  }

  /**
   *   @deprecated new endpoint introduced /segments-with-mappings which should be used instead of this
   */
  getSegmentList(withCache: boolean = false) {
    this.httpClientUtils.getForJson(`${environment.apiSegments}/segments/segments-with-mappings`, {cache: withCache})
      .onSuccess((response: any) => {
        const segments: SegmentModel[] = SegmentModel.fromList(response);
        this.appStore.dispatch({type: ACTION_TYPES.SEGMENT_LIST_GET, segments});
      })
      .onError((error) => {
        this.appStore.dispatch({type: ACTION_TYPES.SEGMENT_LIST_GET, error: HttpInteraction.errorModel(error)});
      })
      .doIt();
  }

  /**
   *   @deprecated new endpoint introduced /segments-with-mappings which should be used instead of this
   */
  getAllSegments(): Observable<SegmentModel[]> {
    const url = `${environment.apiSegments}/segments/segments-with-mappings`;
    return this.httpClient.getWithCache<SegmentModel[]>(url);
  }

  getSegmentListForValidation() {
    this.httpClientUtils.getForJson(`${environment.apiSegments}/segments`)
      // TODO: find right type
      .onSuccess((response: any) => {
        const segments = SegmentModel.fromList(response.data || response as SegmentModel[]);
        this.appStore.dispatch({type: ACTION_TYPES.SEGMENT_LIST_GET_FOR_VALIDATION, segments});
      })
      .onError((error) => {
        this.appStore.dispatch({
          type: ACTION_TYPES.SEGMENT_ERROR,
          error: HttpInteraction.errorModel(error)
        });
      })
      .doIt();
  }

  // todo: we need a new way here (e.g. remove redux action)
  createSegment(newSegment: SegmentModel, callback?: (val: SegmentModel) => void, apiVersion: ApiVersion = ApiVersion.V1) {
    this.httpClientUtils.post(`${environment.apiSegments}/segments`, newSegment, apiVersionHeader(apiVersion))
      .onSuccess((response: any) => {
        const segment = SegmentModel.from((response.data || response) as SegmentModel);
        if (!callback) {
          this.appStore.dispatch(segmentCreated({segment}));
        }
        if (callback) {
          callback(segment);
        }
      })
      .onError((error) => {
        this.appStore.dispatch(segmentCreationError({error: HttpInteraction.errorModel(error)}));
      })
      .doIt();
  }
}
